// extracted by mini-css-extract-plugin
export var actionButton = "_ic-t";
export var buttonContainer = "_ic-0";
export var buttonContainer2 = "_ic-1";
export var buttonSection = "_ic-2";
export var details = "_ic-3";
export var dropdownItem = "_ic-5";
export var dropdownItemsContainer = "_ic-4";
export var fileInput = "_ic-r";
export var headerButton = "_ic-6";
export var icon = "_ic-7";
export var input = "_ic-8";
export var macroListItem = "_ic-9";
export var mainContent = "_ic-a";
export var microText = "_ic-b";
export var modal = "_ic-w";
export var optionsButton = "_ic-c";
export var paperclip = "_ic-s";
export var pillContent = "_ic-d";
export var preview = "_ic-e";
export var preview2 = "_ic-f";
export var quillEditor = "_ic-q";
export var selectedMacro = "_ic-g";
export var sidebar = "_ic-h";
export var sidebarHeader = "_ic-j";
export var sidebarList = "_ic-i";
export var sidebarListItem = "_ic-k";
export var sidebarSearch = "_ic-l";
export var snoozeDurationWrapper = "_ic-v";
export var statusPillContainer = "_ic-m";
export var tagsContainer = "_ic-n";
export var unselectedMacro = "_ic-o";
export var variable = "_ic-u";
export var wrapper = "_ic-p";